import inquiriesStore from './inquiries'

export default {
  modules: {
    inquiries: {
      namespaced: true,
      ...inquiriesStore
    }
  }
}
